import { cn } from "@faire/prototype-playground/lib/utils";
import { Button } from "@faire/slate/components/button";
import React from "react";

import { CREAM, PADX } from "../constants";

interface EditorialBannerProps {
  imageUrl?: string;
  lineOne: string;
  lineTwo?: string;
  ctaLabel?: string;
  /** When set, the CTA navigates here (brand.com → Faire). */
  href?: string;
  /** When set, takes priority over `href` — an in-app action (e.g. switching
   * tabs) instead of a hard navigation. */
  onCtaClick?: () => void;
}

export const EditorialBanner: React.FC<EditorialBannerProps> = ({
  imageUrl,
  lineOne,
  lineTwo,
  ctaLabel = "Shop now",
  href,
  onCtaClick,
}) => (
  <div className={cn("py-6", PADX)}>
    <div className="bg-fs-surface-secondary relative aspect-[16/5] w-full overflow-hidden rounded-xl">
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={lineOne}
          className="h-full w-full object-cover"
        />
      ) : null}
      <div
        className="absolute inset-0 flex flex-col items-center justify-center gap-5 text-center"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.15) 75%)",
        }}
      >
        <div style={{ color: CREAM }}>
          <p className="type-fs-display-s" style={{ color: CREAM }}>
            {lineOne}
          </p>
          {lineTwo ? (
            <p className="type-fs-display-s" style={{ color: CREAM }}>
              {lineTwo}
            </p>
          ) : null}
        </div>
        <Button
          variant="secondary"
          size="small"
          onClick={
            onCtaClick ??
            (href
              ? () => {
                  window.location.href = href;
                }
              : undefined)
          }
        >
          {ctaLabel}
        </Button>
      </div>
    </div>
  </div>
);
